export default __webpack_public_path__ + "static/media/ProntoIntervento.aee0c678.png";